<template>
  <div>
    <v-card v-if="showBuscadorCupos" class="pt-4 grey lighten-4" :img="app.bkBuscador">
      <v-container fluid>
        <BuscadorCupo />
      </v-container>
    </v-card>
    <ContenedorRsCupos />
  </div>
</template>

<script>
// @ is an alias to /src
import BuscadorCupo from "@/components/cupos/BuscadorCupo.vue"
import ContenedorRsCupos from "@/components/cupos/ContenedorRsCupos.vue"
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import moment from "moment"
export default {
  name: "cuposAereos",
  components: {
    BuscadorCupo,
    ContenedorRsCupos
  },
  created() {},
  mounted() {
    this.init()
  },
  beforeCreate() {},
  methods: {
    ...mapActions("carrito", {
      limpiarCarrito: "limpiar"
    }),
    init() {
      this.limpiarCarrito()
      this.setApp()
      this.$store.dispatch("app/setFormSave", null)
      this.$store.dispatch("app/setFormSaveTicket", null)
    },
    async setApp() {
      this.showBuscadorCupos = false
      await this.$store.dispatch("app/saveFormConfigHtl", this.formConfig)
      await this.$store.dispatch("app/saveApp", this.$route.meta.app)
      this.showBuscadorCupos = true
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init()
    })
  },
  data() {
    return {
      showBuscadorCupos: false,
      formConfig: {
        ocupacion: [{ adultos: 2, edades: [] }],
        picker: {
          startDate: moment()
            .add(2, "days")
            .toDate(),
          endDate: moment()
            .add(365, "days")
            .toDate(),
          i18n: {
            night: "Noche",
            nights: "Noches",
            "day-names": moment.localeData("es").weekdaysMin(),
            "check-in": "Llegada",
            "check-out": "Salida",
            "month-names": moment.localeData("es").months()
          },
          minNoches: 1,
          maxNoches: 14
        },
        alternativo: 1
      }
    }
  },
  computed: {
    ...mapGetters("app", {
      app: "getApp"
    })
  },
  beforeRouteLeave(to, from, next) {
    // Se limpia el resultado ya que utilizan los mismos componentes
    if (to.name === "cuposAereosSolo" || to.name === "cuposAereos") {
      this.$store.dispatch("cupo/guardarCuposRs", {
        cupos: [],
        busqueda: null,
        limpiando: true
      })
    }
    next()
  }
}
</script>
